export default {
  methods: {
    /**
     * @name downloadAppFunc
     * @description 下载app
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-10 16:18:37
     */
    downloadAppFunc() {
      this.globalDownload({
        url: window.appDownloadUrl,
        method: "post"
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/views/home-mixin.js